import { useCallback, useState } from 'react';
import Cookies from 'js-cookie';

// A cookie, not localStorage: logging out (or an expired session) clears
// localStorage, and a dismissed tip should stay dismissed in this browser.
const TIP_HIDDEN_COOKIE = 'bulkOpsNumberFilterTipHidden';
// The longest lifetime browsers allow a cookie
const TIP_HIDDEN_DAYS = 400;

/**
 * Remembers in this browser that the Number filter tip on Bulk Operations was
 * dismissed. It only shows again in another browser.
 *
 * @returns {[boolean, () => void]} whether it is hidden, and a hide callback
 */
const useNumberFilterTipHidden = () => {
    const [isHidden, setIsHidden] = useState(
        () => Cookies.get(TIP_HIDDEN_COOKIE) === 'true',
    );

    const hide = useCallback(() => {
        setIsHidden(true);
        Cookies.set(TIP_HIDDEN_COOKIE, 'true', {
            expires: TIP_HIDDEN_DAYS,
            sameSite: 'Lax',
        });
    }, []);

    return [isHidden, hide];
};

export default useNumberFilterTipHidden;
